import Link from "next/link";
import { Suspense } from "react";
import { staticNavLinks, authLinks } from "@/config/nav-links";
import ClientNavbar from "./header-client";

interface NavbarProps {
    active: string;
    navBarHidden?: boolean;
}

/**
 * Server Component Header Wrapper
 * 
 * This component provides SEO benefits by rendering static navigation links
 * that are visible in the page source for search engine crawlers.
 * 
 * The static nav uses `sr-only` class to be:
 * - Hidden visually for users
 * - Present in DOM for search engines and screen readers
 * - Rendered server-side in the initial HTML
 */
export default function Navbar({ active, navBarHidden }: NavbarProps) {
    return (
        <>
            {/* SEO-friendly static navigation - rendered server-side */}
            {!navBarHidden && (
                <nav
                    className="sr-only"
                    aria-label="Site navigation"
                    itemScope
                    itemType="https://schema.org/SiteNavigationElement"
                >
                    <ul>
                        {staticNavLinks.map((item) => (
                            <li key={item.label} itemProp="name">
                                <Link href={item.href} itemProp="url">
                                    {item.label}
                                </Link>
                            </li>
                        ))}
                        {authLinks.map((item) => (
                            <li key={item.label} itemProp="name">
                                <Link href={item.href} itemProp="url">
                                    {item.label}
                                </Link>
                            </li>
                        ))}
                    </ul>
                </nav>
            )}

            {/* Interactive client-side header */}
            <Suspense fallback={null}>
                <ClientNavbar active={active} navBarHidden={navBarHidden} />
            </Suspense>
        </>
    );
}

